import { getWebInstrumentations, initializeFaro } from "@grafana/faro-web-sdk";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";

import { config } from "~/config";
import { trackPageloadSlo } from "./faroPageloadSlo";

// Grafana Cloud Faro RUM の初期化。collector URL は amplify.yml が SSM 経由で注入する。
export const initFaro = () => {
  // URL 未設定（ローカル / terraform apply 前）では起動しない
  if (!config.faroCollectorUrl) {
    return;
  }

  const faro = initializeFaro({
    url: config.faroCollectorUrl,
    app: {
      name: "dewey",
      environment: config.environment,
    },
    // presigned URL(S3 等)は X-Amz-* 署名をクエリに含むため、amazonaws.com 宛は計装・送信から除外する（署名漏洩防止）
    ignoreUrls: [/https:\/\/.*\.amazonaws\.com/i],
    instrumentations: [
      // console capture は無効化: エラー監視は Sentry 担当（方針 X.4）。Loki コスト/二重送信を避ける
      ...getWebInstrumentations({ captureConsole: false }),
      // fetch/XHR トレース。別オリジンへ traceparent は伝播しない（trace-id 共有は Non-Goal）
      new TracingInstrumentation(),
    ],
  });

  // Wire pageload SLO tracking: send the denominator (total) and the numerator
  // (good, derived from LCP/INP/errors/request failures) once when the page
  // becomes hidden. Building the increments into cumulative counters is the
  // collector's (Alloy) job.
  trackPageloadSlo(faro, {
    service: "dewey",
    env: config.environment ?? "unknown",
  });
};
